import { styled, Typography } from '@ori-ui/mui';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { localization } from '../../shared/constants';

interface ReviewSectionProps {
  readonly reviewAction?: React.ReactChild;
  readonly reviewContent?: React.ReactChild;
  readonly labelKey: keyof typeof localization;
}

const StyledReviewSection = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateAreas: `
    "review-label review-action"
    "review-content review-action"
    `,
  gridTemplateColumns: '1fr auto',
  rowGap: theme.spacing(1),
}));

const ReviewAction = styled('div')`
  align-self: 'center';
  justify-self: 'center';
  grid-area: review-action;
`;

const ReviewSectionComponent = ({ reviewAction, reviewContent, labelKey }: ReviewSectionProps) => {
  if (typeof reviewContent === 'undefined') {
    return null;
  }

  return (
    <StyledReviewSection>
      <Typography
        variant="caption"
        style={{ gridArea: 'review-label' }}
        color="textSecondary"
      >
        <FormattedMessage
          id={labelKey}
          defaultMessage={localization[labelKey]}
        />
      </Typography>
      <Typography style={{ gridArea: 'review-content' }}>{reviewContent}</Typography>
      <ReviewAction>{reviewAction}</ReviewAction>
    </StyledReviewSection>
  );
};

const ReviewSection = memo<ReviewSectionProps>(ReviewSectionComponent);

export default ReviewSection;
